<template>
    <div class="cointainer">

        <!-- BUY CREDITS MODAL -->
        <b-modal id="openBuyCreditsModal" title="Buy Credit Packages" @shown="getPackages" @hidden="reset" size="lg" modal-class="agent-netenglish-modal">

            <div v-if="isLoading == true">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>

            <div v-if="isLoading == false">

                <div v-if="isSuccess == true" class="text-center">
                    <div class="alert alert-success" role="alert">
                        {{ this.message }}
                    </div>
                </div>

                <!-- [START] PACKAGES -->
                <div v-if="hasSelectedPackage === false">


                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4 px-1" v-for="(packageItem, index) in packages"
                            :key="'package-' + index">

                            <div class="card esi-card mb-2">

                                <div class="card-header bg-primary text-white">{{ packageItem.name }}</div>

                                <div class="card-body">

                                    <p class="card-text bg-light">
                                        This plan allows you to purchase {{ packageItem.credits }} points for ￥{{ Math.floor(packageItem.amount) }}
                                    </p>

                                    <p v-html="packageItem.description"></p>
                                    <button class="btn btn-sm btn-primary" @click="choosePackage(packageItem)">Choose
                                        Package</button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <!-- [END] PACKAGES -->


                <div v-else>
                    <form @submit.prevent="submitForm">
                        <b-form-group label-class="small" label="Enter Credits To Purchase" label-for="addCredits"
                            :invalid-feedback="formErrors.addCredits">
                            <b-form-input type="text" id="addCredits" placeholder="Enter credits to purchase"
                                v-model="form.addCredits" :state="formErrors.addCredits ? false : null" readonly
                                size="sm" @input="validate('addCredits')"></b-form-input>
                        </b-form-group>

                        <b-form-group label-class="small" label="Total Amount to Pay" label-for="addCredits"
                            :invalid-feedback="formErrors.addCredits">
                            <b-form-input :placeholder="form.totalAmount" v-model="form.totalAmount" readonly
                                size="sm"></b-form-input>
                        </b-form-group>
                    </form>
                </div>
            </div>

            <template #modal-footer>
                <button class="btn btn-secondary" @click="handleCancelClick"
                    v-show="!hasSelectedPackage">Cancel</button>
                <button class="btn btn-secondary" @click="handleBackClick" v-show="hasSelectedPackage">Back</button>

                <!--
                <button class="btn btn-primary" :disabled="!hasSelectedPackage" @click="handleBuyOkayForm">{{ hasSelectedPackage ? 'Buy' : 'Buy' }}</button>
                -->
                <button class="btn btn-primary" :disabled="!hasSelectedPackage" @click="handlePaypalForm">{{
                    hasSelectedPackage ? 'Buy' : 'Buy' }}</button>

            </template>

        </b-modal>

    </div>
</template>




<script>
export default {
    props: {
        firstname: String,
        credits: Number,
        credits_expiration: String,
        latest_date_of_purchase: String,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            message: '',

            hasSelectedPackage: false,
            packages: [],

            //BUY FORM
            form: {
                addCredits: '',
                totalAmount: '0.00',
                selectTransactionOptions: null,
                expiryDate: null
            },
            formErrors: {
                selectTransactionOptions: null,
                addCredits: null,
            },
            fieldNames: {
                addCredits: 'Credits',
                selectTransactionOption: 'Transaction Type'
            },


            creditRate: 3,
            //agent current accont info
            account: {
                credits: 0,
                dateOfPurchase: '',
                creditsExpiration: '',
            },

            //View Member Account Info
            member: {
                credits: 0,
                dateOfPurchase: '',
                creditsExpiration: '',
            },

            members: [],
        };
    },
    mounted() {
        window.openBuyCreditsModal = this.openBuyCreditsModal;
        this.updateAccountInfo({
            credits: this.$props.credits,
            dateOfPurchase: this.$props.latest_date_of_purchase,
            creditsExpiration: this.$props.credits_expiration
        });
    },
    methods: {
        openBuyCreditsModal() {
            this.$bvModal.show('openBuyCreditsModal');
        },
        choosePackage(packageItem) {
            this.hasSelectedPackage = true;
            this.form = {
                addCredits: packageItem.credits,
                totalAmount: Math.floor(packageItem.amount)
            }
        },
        handlePaypalForm($event) {

            // Data to be sent in the form
            const formData = {
                agent_user_id: this.$props.agent_user_id, // Example value
                credits: this.form.addCredits,            // Example value
                price: this.form.totalAmount,             // Example value
                amount: this.form.totalAmount             // Example value
            };

            console.log(formData);

            // Create a new form element
            const form = document.createElement('form');
            form.method = 'POST'; // POST method
            form.action = '/admin/paypal/payment'; // Set your server endpoint here

            // Dynamically create and append input fields to the form
            for (let key in formData) {
                if (formData.hasOwnProperty(key)) {
                    const input = document.createElement('input');
                    input.type = 'text'; // Use hidden inputs to send data
                    input.name = key; // Set the name attribute to match form data key
                    input.value = formData[key]; // Set the value to the form data
                    form.appendChild(input); // Append the input to the form
                }
            }

            // Append the form to the body (it won't be visible to the user)
            document.body.appendChild(form);


            const csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

            // Add CSRF token to the form data
            const csrfInput = document.createElement('input');
            csrfInput.type = 'hidden';
            csrfInput.name = '_token'; // CSRF token field name
            csrfInput.value = csrfToken; // Set the CSRF token value
            form.appendChild(csrfInput);

            // Submit the form
            form.submit(); // Programmatically submit the form            

        },

        handleBackClick() {
            this.reset();
        },
        handleCancelClick() {
            this.$bvModal.hide('openBuyCreditsModal');
            this.reset();
        },
        reset() {
            this.hasSelectedPackage = false;
            this.isLoading = false;
            this.isSuccess = false;
            this.message = '';
            this.form = {
                addCredits: '',
                totalAmount: 0,
            }
        },
        updateAccountInfo(data) {
            //current accont info
            this.account.credits = data.credits;
            this.account.dateOfPurchase = data.dateOfPurchase;
            this.account.creditsExpiration = data.creditsExpiration;
        },
        validateForm() {
            let isValid = true;
            Object.keys(this.form).forEach(field => {
                if (!this.form[field]) {
                    this.$set(this.formErrors, field, `${this.fieldNames[field]} is required`);
                    isValid = false;
                }
            });
            return isValid;
        },
        validateField(fieldName) {

            // Reset the error for the field being validated
            this.$set(this.formErrors, fieldName, null);

            // Check if the field is empty
            if (!this.form[fieldName]) {
                this.$set(this.formErrors, fieldName, `${this.fieldNames[fieldName]} is required`);
            }

            if (fieldName === 'credits' || fieldName === 'addCredits') {
                const creditsValue = parseFloat(this.form.addCredits);
                if (isNaN(creditsValue) || creditsValue <= 0) {
                    this.$set(this.formErrors, 'addCredits', 'Credits must be a positive number above zero');
                }
            }
        },


        handleBuyOkayForm($event) {
            $event.preventDefault();  // This prevents the default close behavior of the modal
            this.submitBuyCreditForm();        // Call your form submission logic
        },        
        submitBuyCreditForm() {
            this.isSuccess = false;

            if (this.validateForm()) {

                axios.post("/api/buy_agent_credit?api_token=" + this.api_token, {
                    method: "POST",
                    agent_user_id: this.$props.agent_user_id,
                    credits: this.form.addCredits,
                    price: this.form.totalAmount,
                    amount: this.form.totalAmount
                }).then(response => {
                    if (response.data.success === false) {
                        alert(response.data.message);
                    } else {

                        this.updateAccountInfo({
                            credits: response.data.account.credits,
                            dateOfPurchase: response.data.account.latest_date_of_purchase,
                            creditsExpiration: response.data.account.credits_expiration
                        });

                        this.isSuccess = true;
                        this.message = response.data.message;

                        let data = {
                            credits: response.data.account.credits,
                            dateOfPurchase: response.data.account.latest_date_of_purchase,
                            creditsExpiration: response.data.account.credits_expiration
                        };
                        this.$emit('get-agent-credit', data);

                        setTimeout(() => {
                            this.$bvModal.hide('openBuyCreditsModal');
                            this.reset()
                        }, 2500);
                    }

                }).catch(function (error) {
                    alert("Error " + error);
                });
                console.log('Form submitted', this.form);
            }
        },

       
        handleSendMemberCreditModalOkClick($event) {

            if (this.validateForm()) {

                axios.post("/api/updateMemberCredits?api_token=" + this.api_token, {
                    method: "POST",
                    agent_user_id: this.$props.agent_user_id,
                    form: this.form
                }).then(response => {

                    if (response.data.success === false) {
                        alert(response.data.message);
                    } else {
                        this.message = response.data.message;
                        this.members = response.data.memberlist;

                        //this.$emit('update-agent-credit', this.agentID, this.credit, this.amount, this.transactionType);                       
                    }

                }).catch(function (error) {
                    alert("Error " + error);
                });
            }
        },

        //Get Packages 
        getPackages($event) {

            axios.post("/api/getPackages?api_token=" + this.api_token, {
                method: "POST",
                agent_user_id: this.$props.agent_user_id,
            }).then(response => {
                if (response.data.success === false) {
                    alert(response.data.message);
                } else {
                    this.packages = response.data.packages;
                }
            }).catch(function (error) {
                alert("Error " + error);
            });

        }
    },


};
</script>